import { render, staticRenderFns } from "./PublicLink.vue?vue&type=template&id=4138db42&scoped=true&"
import script from "./PublicLink.vue?vue&type=script&lang=js&"
export * from "./PublicLink.vue?vue&type=script&lang=js&"
import style0 from "./PublicLink.vue?vue&type=style&index=0&id=4138db42&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4138db42",
  null
  
)

export default component.exports